export default __webpack_public_path__ + "static/media/caza.db649323.jpg";